"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SectionHeader = exports.Name = exports.DisabledTitle = exports.BillingAddressWrapper = exports.AddressFormWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../CheckoutStep/styles");
const BillingAddressWrapper = exports.BillingAddressWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        ...(0, _styles.sectionStyles)(theme)
    };
});
const SectionHeader = exports.SectionHeader = (0, _mui.styled)('div')({
    ...(0, _styles.sectionHeaderStyles)()
});
const DisabledTitle = exports.DisabledTitle = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.default.light
    };
});
const Name = exports.Name = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        fontWeight: 'bold',
        margin: theme.spacing(3, 0, 1)
    };
});
const AddressFormWrapper = exports.AddressFormWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        marginTop: theme.spacing(5)
    };
});
